import React from 'react';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { Endereco } from '../../types/pessoas';
import { cidadesService, enderecosService } from '../../services';
import { makeOptionLoader } from '../../utils/optionLoaders';

const fields: ResourceField<Endereco>[] = [
  { name: 'logradouro', label: 'Logradouro', required: true },
  { name: 'complemento', label: 'Complemento' },
  { name: 'bairro', label: 'Bairro', required: true },
  { name: 'cep', label: 'CEP', required: true },
  {
    name: 'cidade',
    label: 'Cidade',
    type: 'async-select',
    valueType: 'number',
    loadOptions: makeOptionLoader(
      cidadesService.list,
      (item: any) => (item.uf_sigla ? `${item.nome} - ${item.uf_sigla}` : item.nome),
    ),
    required: true,
  },
];

export const EnderecosFormPage: React.FC = () => (
  <ResourceFormPage
    title="Novo endereço"
    description="Cadastre endereços para vincular a fornecedores, clientes e demais entidades."
    fields={fields}
    service={enderecosService}
    redirectPath="/admin/pessoas/enderecos"
    cancelPath="/admin/pessoas/enderecos"
  />
);
